/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import auth from './app/auth';
import LogoutSuccess from '@/components/LogoutSuccess';
import UserInfoStore from './app/user-info-store';
import UserInfoApi from './app/user-info-api';
import ErrorComponent from '@/components/Error';

Vue.use(Router)

function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
//    console.log("User not Logged-In..");
      UserInfoStore.setLoggedIn(false);
      next({
      path: '/login',
      query: { redirect: to.fullPath }
      });
  } else {
//      console.log("User Logged-In..");
      UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);
      next();
    });

  }
}

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/', beforeEnter(to, from, next){
//      console.log("root path invoked");
    },

    name: 'Home',
    component: Home,
    beforeEnter: requireAuth
    },
    {
      path: '/login', beforeEnter(to, from, next){
//        console.log("/login invoked");
        auth.auth.getSession();
      }
    },
    {
      path: '/login/oauth2/code/cognito', beforeEnter(to, from, next){
        var currUrl = window.location.href;
//        console.log("/login/oauth2/code/cognito invoked: ", currUrl);
        auth.auth.parseCognitoWebResponse(currUrl);
        //next();
      }
    },

    {
      path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){
//        console.log("/logout invoked");
        auth.logout();
        next();
      }
    },

    {
      path: '/error', component: ErrorComponent
    },
    {
      path: "/products",
      name: "Products",
      component: () => import(/* webpackChunkName: "Products" */ "@/views/Products"),
      beforeEnter: requireAuth,
    },
    {
      path: "/Pharmacy",
      name: "Pharmacys",
      component: () => import(/* webpackChunkName: "Pharmacys" */ "@/views/Pharmacy"),
      beforeEnter: requireAuth,
    },
    {
      path: "/customer",
      name: "Customers",
      component: () => import(/* webpackChunkName: "Customers" */ "@/views/Customer"),
      beforeEnter: requireAuth,
    },
    {
      path: "/contract",
      name: "Contracts",
      component: () => import(/* webpackChunkName: "Contract" */ "@/views/Contract"),
      beforeEnter: requireAuth,
    },
    {
      path: "/vaccination",
      name: "Vaccination",
      component: () => import(/* webpackChunkName: "Vaccination" */ "@/views/Vaccination"),
      beforeEnter: requireAuth,
    },
    {
      path: "",
      name: "Reports",
      },
    {
      path: "/reports/VaccinationByPharmacy",
      name: "VaccinationByPharmacy",
      component: () => import(/* webpackChunkName: "VaccinationByPharmacy" */ "@/views/Reports/VaccinationByPharmacy"),
      beforeEnter: requireAuth,
    },
    {
      path: "/reports/VaccinationByCustomer",
      name: "VaccinationByCustomer",
      component: () => import(/* webpackChunkName: "VaccinationByCustomer" */ "@/views/Reports/VaccinationByCustomer"),
      beforeEnter: requireAuth,
    },
    {
      path: "/reports/FinanceCustomer",
      name: "FinanceCustomer",
      component: () => import(/* webpackChunkName: "FinanceCustomer" */ "@/views/Reports/FinanceCustomer"),
      beforeEnter: requireAuth,
    },
    {
      path: "/reports/FinancePharmacy",
      name: "FinancePharmacy",
      component: () => import(/* webpackChunkName: "FinancePharmacy" */ "@/views/Reports/FinancePharmacy"),
      beforeEnter: requireAuth,
    },
    {
      path: "/PharmacyUser",
      name: "PharmacyUser",
      component: () => import(/* webpackChunkName: "PharmacyUser" */ "@/views/PharmacyUser"),
      beforeEnter: requireAuth,
    },
    {
      path: "/reports/FinanceCustomerPharmacy",
      name: "FinanceCustomerPharmacy",
      component: () => import(/* webpackChunkName: "FinanceCustomerPharmacyy" */ "@/views/Reports/FinanceCustomerPharmacy"),
      beforeEnter: requireAuth,
    },
    {
      path: "/vaccinationAdmin",
      name: "VaccinationAdmin",
      component: () => import(/* webpackChunkName: "VaccinationAdmin" */ "@/views/VaccinationAdmin"),
      beforeEnter: requireAuth,
    },
  ]
})
